
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getGeographies",
      resolverType: "query",
      routePath: "/getGeographies",
      httpMethod: "POST",
    });
  